import { Schematic } from "../Schematic";
import { SchematicKind } from "../SchematicKind";
import { joinPackages } from "../util/join";
import { ScaffoldingData } from "./ScaffoldingData";
import { ScaffoldingFile, ScaffoldingFileContent } from "./ScaffoldingFile";

export interface ScaffoldOptions {
  schematicKinds: Map<string, SchematicKind>;
  basePath?: string;
  basePackage?: string;
  baseDir?: string;
}

export type Scaffolder<
  TScaffoldingData extends ScaffoldingData = ScaffoldingData,
> = (schematic: Schematic, data: TScaffoldingData) => void;

export interface ScaffoldedFile extends Omit<ScaffoldingFile, "getContent"> {
  path: string;
  content: ScaffoldingFileContent | Promise<ScaffoldingFileContent>;
}

export function scaffold(
  schematic: Schematic,
  scaffolders: Scaffolder<any>[],
  options: ScaffoldOptions,
): ScaffoldedFile[] {
  const files = new Map<string, ScaffoldingFile>();
  const data: ScaffoldingData = {
    schematicKinds: options.schematicKinds,
    rootSchematic: schematic,
    files,
    currentPath: options.basePath ?? "/",
    currentPackage: joinPackages(options.basePackage, schematic.packageSuffix),
    currentDir: options.baseDir,
  };
  for (const scaffolder of scaffolders) {
    scaffolder(schematic, data);
  }
  return Array.from(files).map(([path, file]) => ({
    path,
    content: file.getContent(),
    base64: file.base64,
    binary: file.binary,
    executable: file.executable,
  }));
}
